import dynamic from 'next/dynamic';
import { StayDateGIProps } from './StayDateGI.types';

export const StayDateGI = dynamic<StayDateGIProps>(() => import('./StayDateGI').then(module => module.StayDateGI));
